// extracted by mini-css-extract-plugin
export default {"sectionSearch":"SearchInfo_sectionSearch__MbUQU"};